import { DragAndDrop } from "../components/global/DragAndDrop";
import { motion } from "framer-motion";
import { animationDurationToShowQuestion } from "../config";
import React, { useState, useEffect, useRef } from "react";
import Sound from "../components/global/Sound";
import { CircleButton } from "../components/elements/CircleButton";
import { getCircleComponent } from "../hooks/useCircleButtonColor";
import {wongAnswersLimit} from "../config.js"
import './style.css';



export default function RightPart({ state, answers, checkAnswer, answer, answerSound, hint, getCoordinates, calcGapY }) {
    const colors = useRef(getCircleComponent(answers));
    const [i, setI] = useState('');
    const [time, setTime] = useState(0);
    const [animate, setAnimate] = useState(false);
    const [val, setVal] = useState();
    const [update, setUpdate] = useState(false);
    const soundRef = useRef();
    const soundWrongRef = useRef();
    const [type, setType] = useState(false);
    const [hinted, setHinted] = useState(false);
    const wrongAnswers = useRef([]);
    const [lockedTransform, setLockedTransform] = useState(null);
    const lockRef = useRef(false);
    useEffect(() => {
        if (hint && answer && time >= 10 && time % 2 === 0) {
            setHinted(true);
        }
    }, [hint, answer, time]);


    useEffect(() => {
        if (!animate) return;
        setVal('');
        setAnimate(false);
        setHinted(false);
        setI('');
        setUpdate(false);
        setTime(0);
        wrongAnswers.current = [];
        colors.current = getCircleComponent(answers);
    }, [answers]);

    useEffect(() => {
        if (type && answer) setTimeout(() => {
            setType(false);
            document.querySelector('.addingresult').style.opacity = 1;
        }, 1000);
    }, [type]);

    useEffect(() => {
        if (!hint) return;
        const id = setInterval(() => setTime(prev => prev + 1), 1000);
        return () => clearInterval(id);
    }, [hint]);

    return (
        <div className={`${state ? "rightpartIsStateWidth" : "rightpartIsNotStateWidth"} z-[50] flex flex-col items-center h-full border-[3px] rounded-[16px] lg:rounded-[20px] border-[#7648B5] bg-[#FFF]`}>
            {answers.map((number, index) => {
                if (i === index) {
                    return <DragAndDrop
                        enableClick={true}
                        drop={'adding'}
                        animateWrong={(e) => {
                            setUpdate(index);
                            setTime(0);

                            if (wrongAnswers.current.length < wongAnswersLimit) {
                                checkAnswer("dontmouseup", false, number);
                            }

                            wrongAnswers.current.push(number);
                            setI('');
                            if (answerSound) {
                                soundWrongRef.current.currentTime = 0;
                                soundWrongRef.current.play();
                            }
                        }}
                        key={index} numbers={[answer]} item={number}
                        refresh={(event, type) => {
                            if (event === 'mouseup') return;
                            if (val === number) return; 

                            setType(type);
                            if (!hinted && wrongAnswers.current.length < wongAnswersLimit) checkAnswer(event, type, number);
                            if (!hinted && wrongAnswers.current.length >= wongAnswersLimit) checkAnswer(event, false, number);

                            if (hinted) checkAnswer(event, false, number, true);
                            setVal(number);
                            setUpdate(false);
                            if (type && !lockRef.current) {
                                const [x, y] = getCoordinates();
                                setLockedTransform({ x, y });
                                lockRef.current = true;

                                setTimeout(() => {
                                    lockRef.current = false;
                                    setLockedTransform(null);
                                }, 1000);
                            }
                            if (type) setTimeout(() => document.querySelector('.addingresult').style.opacity = 0, 200);
                            if (answerSound) {
                                soundRef.current.currentTime = 0;
                                soundRef.current.play();
                            }
                        }}>
                        <motion.div
                            style={{
                                marginTop: calcGapY(state) + 'px',
                                transform:
                                    val === number && (type || lockedTransform)
                                        ? `translate(${lockedTransform?.x ?? getCoordinates()[0]}px,
                                                 ${lockedTransform?.y ?? getCoordinates()[1]}px)`
                                        : undefined, transition: `transform ${0.2}s linear`
                            }}
                            className={`relative answer ${val === number && !type ? 'opacity-0' : 'opacity-100'}  ${update === index ? 'animate-wrong' : ''} z-[4000] cursor-pointer`}
                        >
                            <CircleButton isActive={number} color={colors.current[index]}>
                                {number}
                            </CircleButton>
                            {hint && answer === number && time >= 10 && time % 2 === 0 && <div className="bg-[url('/backGrounds/hint.svg')] bg-[position:50%_50%] bg-contain bg-no-repeat absolute w-[50px] h-[50px] top-[50%] z-[100]"></div>}
                        </motion.div>
                    </DragAndDrop>
                } else {

                    return <motion.div
                        key={index} style={{ marginTop: calcGapY(state) + 'px' }} className={`relative z-[4000] cursor-pointer ${update === index ? 'animate-wrong' : ''}`}
                        animate={{ y: animate ? [0, 0] : [(index + 1) * 100, 0] }}
                        transition={{ duration: animationDurationToShowQuestion, type: "tween", ease: "linear" }}

                        onPointerEnter={() => {
                            setI(index);
                            setAnimate(true);
                            setTimeout(() => {
                                setUpdate(false);
                            }, 1000);
                        }}
                    >
                        <CircleButton key={index} isActive={number} color={colors.current[index]}>
                            {number}
                        </CircleButton>
                        {hint && answer === number && time >= 10 && time % 2 === 0 && <div className="bg-[url('/backGrounds/hint.svg')] bg-[position:50%_50%] bg-contain bg-no-repeat absolute w-[50px] h-[50px] top-[50%] z-[100]"></div>}
                    </motion.div>
                }
            })}
            <Sound ref={soundRef} url={"/backGrounds/right_answer.wav"} loop={false} />
            <Sound ref={soundWrongRef} url={"/backGrounds/wrong_answer.wav"} loop={false} />
        </div>
    )
}